export const environment = {
  production: true,
  config: {
    endpoints: {
      api: {
        protocol: "http",
        domain: "bo.performancetraininglab.local",
        port: 80,
        contextPath: "api"
      },
      authApi: {
        protocol: "http",
        domain: "bo.performancetraininglab.local",
        port: 80,
        contextPath: "auth/api"
      },
      iamApi: {
        protocol: "http",
        domain: "bo.performancetraininglab.local",
        port: 80,
        contextPath: "iam/api",
      }
    },
    federatedLogin : false,
    requiredAuthorities: ["BACK_OFFICE_APP"],
    mockUserProfile : false,
    profileRefresh : 10000,
    logToConsole: true,
    enabledLocales: ["it-it"],
    autodetectLocale: true,
    chatRefreshIntervalInSec: 10,
    domain: "bo.performancetraininglab.local",
    cookiesConsentRequired: false,
    cookieConsentExpirationInDay:365,
    sessionKeepAliveIntervalInSec:60,
    attendanceMarkingEnabled:true,
    passwordSettingExpected: true,
    signUpExpected: false,
    emailAsUsername: true
  },
  mockUserProfile : {
    "authorities": ["IAM__USER_PROFILES__READ",
                    "IAM__USER_PROFILES__EDIT",
                    "IAM__USER_PROFILES__DELETE",
                    "IAM__USER_ACCOUNT_GROUPS__READ",
                    "IAM__USER_ACCOUNT_GROUPS__EDIT",
                    "IAM__USER_ACCOUNT_GROUPS__DELETE",
                    "IAM__ROLES__READ",
                    "IAM__ROLES__EDIT",
                    "IAM__ROLES__DELETE",
                    "MESSAGES__SEND",
                    "ROLE_SUPER_ADMIN"],
    "userId": "2",
    "username": "mario.rossi",
    "enabled": true,
    "nickname": null,
    "name": "Mario Rossi",
    "email": "lucaquarello@gmail.com",
    "emailVerified": true,
    "phoneNumber": "+393917148446",
    "phoneNumberVerified": true
  }
}
